import React from 'react'
import Media from 'react-media'

import LargeChat from './LargeChatWrapper'
import SmallChat from './SmallChat'

const Header = props => (
  <Media query="(min-width: 900px)">
    {matches => (matches ? <LargeChat {...props} /> : <SmallChat {...props} />)}
  </Media>
)

export default Header



// WEBPACK FOOTER //
// ./src/pages/Chat/index.js